import { BaseFilterParameter, IBaseFilterParameter } from "../base-filter.parameter";

export interface IDocumentParamter extends IBaseFilterParameter {
  fk_attachment_type?: number[]
  fk_attachment_type_level_2?: number[]
  key?: string
  block?: number[]
  apartment?: number[]
  creator?: number[],
  detail?: string
  attributeFilters?:string
  equipment?:number[]
}
export class DocumentParamter extends BaseFilterParameter implements IDocumentParamter {
  fk_attachment_type?: number[]
  fk_attachment_type_level_2?: number[]
  key?: string
  block?: number[]
  apartment?: number[]
  creator?: number[]
  detail?: string
  attributeFilters?:string
  equipment?:number[]
  /**
   *
   */
  constructor(partial?: Partial<IDocumentParamter>) {
    super(partial);
    this.fk_attachment_type = []
    this.fk_attachment_type_level_2 = []
    this.attributeFilters = '[]'
  }
}



// WEBPACK FOOTER //
// ./src/models/documents/document-parameter.ts